const ONE_DAY = 24 * 60 * 60 * 1000;

// Milestone days that earn a full celebration. Kept rare on purpose:
// celebrations that fire too often stop feeling like rewards.
const MILESTONES = [7, 30, 100, 365];

const dayKey = (d) => new Date(d).toDateString();

/*
 * Compute the current consecutive-day streak from a habit's logs.
 *
 * Returns { count, doneToday, status }:
 *  - status 'active':     the streak ends today or yesterday (today can still
 *                         be checked without losing it).
 *  - status 'repairable': yesterday was missed but the UI still allows
 *                         checking past dates, so the streak can be revived.
 *                         Shown muted rather than as a failure — highlighting
 *                         broken streaks demotivates, repairable ones don't.
 *  - status 'none':       no streak to show (count is 0).
 */
function computeStreak(habitLogs, now = new Date()) {
  const days = new Set((habitLogs || []).map((log) => dayKey(log.recordTs)));
  const doneToday = days.has(dayKey(now));

  // Find where the streak ends: today (0), yesterday (1), or the day before (2).
  let offset = 0;
  while (offset <= 2 && !days.has(dayKey(now.getTime() - offset * ONE_DAY))) {
    offset++;
  }
  if (offset > 2) {
    return { count: 0, doneToday, status: 'none' };
  }

  let count = 0;
  let t = now.getTime() - offset * ONE_DAY;
  while (days.has(dayKey(t))) {
    count++;
    t -= ONE_DAY;
  }

  return { count, doneToday, status: offset === 2 ? 'repairable' : 'active' };
}

function isMilestone(count) {
  return MILESTONES.includes(count);
}

export { computeStreak, isMilestone, MILESTONES };
